import { useStoredPreference } from '@cmg/auth';
import type { LocaleCode } from '@cmg/i18n';

export type UserSettings = { locale: LocaleCode };

export const USER_SETTINGS_INITIAL_VALUE: UserSettings = { locale: 'en-US' };

const USER_SETTINGS_KEY = 'USER_SETTINGS';

export const useStoredUserSettings = () =>
  useStoredPreference<UserSettings>({
    key: USER_SETTINGS_KEY,
    initialValue: USER_SETTINGS_INITIAL_VALUE,
    storageType: 'Local',
  });
